<template>
  <div class="patents-page">
    <PageTitle
      title="How It Works"
      subtitle="A quick breakdown of how our service works, and ways you can use it to build synchronized video apps."
      backgroundClass="is-dark -banner -banner-14"
    />
    <section class="section">
      <div class="container">
        <TheProblem class="has-margin-bottom-30" />
        <WhatWeProvide />
      </div>
    </section>
  </div>
</template>

<script>
import PageTitle from "@/components/PageTitle.vue";
import TheProblem from "@/components/library/TheProblem.vue";
import WhatWeProvide from "@/components/library/WhatWeProvide.vue";

export default {
  name: "howItWorksPage",
  components: {
    PageTitle,
    TheProblem,
    WhatWeProvide
  },
  data() {
    return {
      features: [
        {
          imagePath: require("@/assets/img/icons/01.svg"),
          name: "Resources",
          description:
            "A set of open-source client libraries, documentation, and demos for fast and simple integration."
        },
        {
          imagePath: require("@/assets/img/icons/02.svg"),
          name: "Tooling",
          description:
            "A RESTful JSON API and SDK with useful methods and endpoints to cover a wide variety of use-cases."
        },
        {
          imagePath: require("@/assets/img/icons/03.svg"),
          name: "Storage",
          description:
            "We provide storage options for those who want to avoid managing a backend."
        }
      ]
    };
  }
};
</script>

<style scoped lang="scss"></style>
